import React, { useState, useRef, useMemo } from 'react';
import JoditEditor from "jodit-react";
import { useNavigate } from 'react-router-dom';
import { ProtectAPi } from '../../../../api/ProtectAPi';
import swal from 'sweetalert';
import BackButton from '../../../tools/BackButton';

const CaseAdd = () => {
  const navigate = useNavigate();
  const editor = useRef(null);
  const { http } = ProtectAPi();
  const [loader, setLoader] = useState('off');
  const [caseCategory, setCaseCategory] = useState('');
  const [caseTitle, setCaseTitle] = useState('');
  const [caseSlug, setCaseSlug] = useState('');
  const [caseDescription, setCaseDescription] = useState('');
  const [caseCategoryError, setCaseCategoryError] = useState('');
  const [caseTitleError, setCaseTitleError] = useState('');
  const [caseSlugError, setCaseSlugError] = useState('');
  const [caseDescriptionError, setCaseDescriptionError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'caseCategory') setCaseCategory(value);
    else if (name === 'caseTitle') setCaseTitle(value);
    else if (name === 'caseSlug') setCaseSlug(value);
  };

  const submitForm = () => {
    setLoader('on');
    setCaseCategoryError('');
    setCaseTitleError('');
    setCaseSlugError('');
    setCaseDescriptionError('');

    const formData = new FormData();
    formData.append('category', caseCategory);
    formData.append('title', caseTitle);
    formData.append('slug', caseSlug); // add slug
    formData.append('description', caseDescription);

    http.post(`/add-case-study`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => {
      if (res.data.status === '422') {
        const errors = res.data.error;
        setLoader('off');
        setCaseCategoryError(errors.category || '');
        setCaseTitleError(errors.title || '');
        setCaseSlugError(errors.slug || '');
        setCaseDescriptionError(errors.description || '');
      } else {
        setLoader('off');
        navigate('/admin/pages/case-study-list');
        swal('Success', res.data.msg, 'success');
      }
    }).catch(error => {
      console.error('Error:', error);
      setLoader('off');
    });
  };

  const placeholder = 'Start typing...';
  const editorConfig = useMemo(() => ({
    readonly: false,
    placeholder,
    uploader: { insertImageAsBase64URI: true }
  }), [placeholder]);

  return (
    <div>
      <div className="main-content">
        <section className="section">
          <div className="section-body">
            <div className="row">
              <div className="col-12">
                <div className="card card-primary">
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                      <h5>Add New Case</h5>
                      <BackButton />
                    </div>
                    <div className="card-body pb-0">
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <label>Case Study Category</label>
                          <input
                            type="text"
                            name="caseCategory"
                            value={caseCategory}
                            className="form-control"
                            placeholder='Case category'
                            onChange={handleInputChange}
                          />
                          <span className='text-danger'>{caseCategoryError}</span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <label>Case Study Title</label>
                          <input
                            type="text"
                            name="caseTitle"
                            value={caseTitle}
                            className="form-control"
                            placeholder='Case title'
                            onChange={handleInputChange}
                          />
                          <span className='text-danger'>{caseTitleError}</span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <label>Slug (optional)</label>
                          <input
                            type="text"
                            name="caseSlug"
                            value={caseSlug}
                            className="form-control"
                            placeholder='Slug'
                            onChange={handleInputChange}
                          />
                          <span className='text-danger'>{caseSlugError}</span>
                        </div>
                        <div className="col-md-12 mt-4">
                          <label>Case Study Description</label>
                            <JoditEditor
                            ref={editor}
                            value={caseDescription}
                            config={{
                                readonly: false,
                                placeholder: 'Start typing...',
                                height: 300,
                                uploader: {
                                insertImageAsBase64URI: true
                                }
                            }}
                            tabIndex={1}
                            onBlur={newContent => setCaseDescription(newContent)}
                            onChange={() => {}}
                            />

                          <span className='text-danger'>{caseDescriptionError}</span>
                        </div>

                        <div className="col-md-12 mt-5 mb-4">
                            {loader === 'off' ? (
                                <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Create</button>
                            ) : (
                                <div className="spinner-border text-dark" role="status"></div>
                            )}
                        </div>

                      </div>
                    </div>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CaseAdd;
